export default "__VITE_ASSET__ps20wiPW__"